var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 32,
    viewBox: "0 0 39 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 16.1934C38.75 16.5762 38.5996 16.918 38.2988 17.2188L24.4766 31.041C24.1758 31.3281 23.8408 31.4717 23.4717 31.4717C23.0889 31.4717 22.7676 31.3418 22.5078 31.082C22.2617 30.8359 22.1387 30.5283 22.1387 30.1592C22.1387 29.9678 22.166 29.7832 22.2207 29.6055C22.2754 29.4277 22.3643 29.2842 22.4873 29.1748L28.6602 22.9404L35.6533 16.46L35.9814 17.2803L29.9316 17.5674H2.02051C1.62402 17.5674 1.2959 17.4375 1.03613 17.1777C0.790039 16.918 0.666992 16.5898 0.666992 16.1934C0.666992 15.7969 0.790039 15.4688 1.03613 15.209C1.2959 14.9492 1.62402 14.8193 2.02051 14.8193H29.9316L35.9814 15.1064L35.6533 15.9473L28.6602 9.44629L22.4873 3.21191C22.3643 3.08887 22.2754 2.94531 22.2207 2.78125C22.166 2.60352 22.1387 2.41895 22.1387 2.22754C22.1387 1.8584 22.2617 1.55078 22.5078 1.30469C22.7676 1.04492 23.0889 0.915039 23.4717 0.915039C23.6631 0.915039 23.8477 0.956055 24.0254 1.03809C24.2031 1.10645 24.3877 1.24316 24.5791 1.44824L38.2988 15.168C38.5996 15.4551 38.75 15.7969 38.75 16.1934Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.26d251597a5f01ee0d054590d69999fd.svg";
export { ForwardRef as ReactComponent };